import NotificationService from '../services/notification'

const mutations = {
  FETCH_NOTIFICATIONS_REQUEST(state) {
    state.isFetchingNotifications = true
  },
  FETCH_NOTIFICATIONS_SUCCESS(state, payload) {
    state.isFetchingNotifications = false
    state.notifications = payload
  },
  FETCH_NOTIFICATIONS_FAILURE(state) {
    state.isFetchingNotifications = false
  },
  ADD_NOTIFICATION_REQUEST(state) {
    state.isCreatingNotification = true
  },
  ADD_NOTIFICATION_SUCCESS(state) {
    state.isCreatingNotification = false
  },
  ADD_NOTIFICATION_FAILURE(state) {
    state.isCreatingNotification = false
  },
  DELETE_NOTIFICATION_REQUEST(state) {
    state.isDeletingNotification = true
  },
  DELETE_NOTIFICATION_SUCCESS(state) {
    state.isDeletingNotification = false
  },
  DELETE_NOTIFICATION_FAILURE(state) {
    state.isDeletingNotification = false
  },
  FETCH_NOTIFICATION_BY_ID_REQUEST(state) {
    state.isFetchingNotification = true
  },
  FETCH_NOTIFICATION_BY_ID_SUCCESS(state, payload) {
    state.isFetchingNotification = false
    state.notificationDetail = payload
  },
  FETCH_NOTIFICATION_BY_ID_FAILURE(state) {
    state.isFetchingNotification = false
  },
  UPDATE_NOTIFICATION_REQUEST(state) {
    state.isUpdatingNotification = true
  },
  UPDATE_NOTIFICATION_SUCCESS(state) {
    state.isUpdatingNotification = false
  },
  UPDATE_NOTIFICATION_FAILURE(state) {
    state.isUpdatingNotification = false
  },
}

const actions = {
  async fetchNotifications(
    { commit, dispatch },
    { limit = '', page = '', search = '', masterId = '', agentId = '' }
  ) {
    try {
      commit('FETCH_NOTIFICATIONS_REQUEST')
      const response = await NotificationService.fetch(
        limit,
        page,
        search,
        masterId,
        agentId
      )
      commit('FETCH_NOTIFICATIONS_SUCCESS', response)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_NOTIFICATIONS_FAILURE', e.message)
    }
  },
  async createNotification({ commit, dispatch }, data) {
    try {
      commit('ADD_NOTIFICATION_REQUEST')
      await NotificationService.create(data)
      commit('ADD_NOTIFICATION_SUCCESS')
      dispatch('notifySuccess', 'added')
      dispatch('fetchNotifications', {
        limit: '',
        page: '',
        search: '',
        masterId: '',
        agentId: '',
      })
    } catch (e) {
      dispatch('notifyError', e)
      commit('ADD_NOTIFICATION_FAILURE', e.message)
    }
  },
  async deleteNotification({ commit, dispatch }, id) {
    try {
      commit('DELETE_NOTIFICATION_REQUEST')
      await NotificationService.delete(id)
      commit('DELETE_NOTIFICATION_SUCCESS')
      dispatch('fetchNotifications', {
        limit: '',
        page: '',
        search: '',
        masterId: '',
        agentId: '',
      })
    } catch (e) {
      dispatch('notifyError', e)
      commit('DELETE_NOTIFICATION_FAILURE', e.message)
    }
  },
  async fetchNotificationById( { commit, dispatch }, id ) {
    try {
      commit('FETCH_NOTIFICATION_BY_ID_REQUEST')
      const response = await NotificationService.findById(id )
      commit('FETCH_NOTIFICATION_BY_ID_SUCCESS', response)
    } catch (e) {
      dispatch('notifyError', e)
      commit('FETCH_NOTIFICATION_BY_ID_FAILURE', e.message)
    }
  },
  async updateNotification({ commit, dispatch }, {id, data}) {
    try {
      commit('UPDATE_NOTIFICATION_REQUEST')
      await NotificationService.update(id, data)
      commit('UPDATE_NOTIFICATION_SUCCESS')
      dispatch('notifySuccess', 'updated')
      dispatch('fetchNotifications', {
        limit: '',
        page: '',
        search: '',
        masterId: '',
        agentId: '',
      })
    } catch (e) {
      dispatch('notifyError', e)
      commit('UPDATE_NOTIFICATION_FAILURE', e.message)
    }
  },
}

const getters = {}

const state = {
  isFetchingNotifications: false,
  isCreatingNotification: false,
  isDeletingNotification: false,
  notifications: [],

  isFetchingNotification: false,
  notificationDetail: {},
  isUpdatingNotification: false,
}

export default {
  mutations,
  actions,
  getters,
  state,
}
